import { ProductData } from "@/lib/5874/types";
import { getProductsBySkus } from "@/lib/bigcommerce/product";
import { useEffect, useState } from "react";

const useGetViewedItemsFromLocalStorage = (currentItemId?: number) => {
	const [items, setItems] = useState<ProductData[]>([]);
	const [isLoadingItems, setIsLoadingItems] = useState(true);

	useEffect(() => {
		const getProductData = async () => {
			const skus = localStorage.getItem("ssViewedProducts");

			const products = await getProductsBySkus(skus?.split(",") || []);
			const filtered = currentItemId
				? products?.filter((p) => p.id !== currentItemId)
				: products;
			setItems(filtered);
			setIsLoadingItems(false);
		};

		window.addEventListener("storage", getProductData);
		getProductData();
	}, []);

	return { isLoadingItems, items };
};

export default useGetViewedItemsFromLocalStorage;
